export const studentsTableHead = [
	{
		id: 'No.',
		label: 'No.',
	},
	{
		id: 'name',
		label: 'Name',
	},
	{
		id: 'week1',
		label: 'Week 1',
	},
	{
		id: 'week2',
		label: 'Week 2',
	},
	{
		id: 'week3',
		label: 'Week 3',
	},
	{
		id: 'week4',
		label: 'Week 4',
	},
	{
		id: 'bounes',
		label: 'Bounes',
	},
];
